/* eslint-disable no-use-before-define */
import axios from 'axios'
import API_URL from '../js/API'
import authHeader from './auth-header';
import { downloadRequest } from '../js/download';

// const API = API_URL(API) + '8000/'
const API = API_URL(API) + '/'

class AnnounceService {
    /** 登入驗證 */
    async announce(text) {
        await axios.post(API + 'HRCS/alert_punch', {text: text}, {
            headers: authHeader()
        }).then(res => {
            return {
                code: res.status
            }
        });
    }
}

export default new AnnounceService()